import { AfterViewInit, Component, ElementRef, Inject, NgZone, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { fromEvent } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { DOCUMENT, Location } from '@angular/common';
import { LoginService } from '../../core/login/login.service';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { IframeScrollService } from '../../services/iframe-scroll.service';
import { isEmpty as _isEmpty } from 'lodash';
import { WsbFrontendService } from './wsb-frontend.service';
import $ from 'jquery';

@Component({
  selector: 'wsb-wsb-frontend',
  templateUrl: './wsb-frontend.component.html',
  styleUrls: ['./wsb-frontend.component.scss'],
  standalone: false
})
export class WsbFrontendComponent implements AfterViewInit {
  @ViewChild('wsbiframe', { static: true }) wsbiframe: ElementRef;
  @ViewChild('loadingTemplate', { read: TemplateRef }) loadingTemplate: TemplateRef<any>;

  iframeReady = false;
  overlayRef: OverlayRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private location: Location,
    @Inject(DOCUMENT) private document: Document,
    public overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private iframeScrollService: IframeScrollService,
    private zone: NgZone,
    private wsbFrontendService: WsbFrontendService
  ) {}

  ngAfterViewInit() {
    this.route.url.subscribe((value: UrlSegment[]) => {
      let url = value.reduce((prev: string, curr: UrlSegment) => prev + '/' + curr.path, '');
      // console.log('wsb-frontend afterviewinit url', url);
      if (url === '/user/login') {
        this.navigateToPureAngularRoute('login');
      } else if (url === '/logout' || url === '/user/logout') {
        this.logout(true);
        console.error('NAVIGATING TO PURE ANGULAR ROUTE !!', this.router.url);
        // this.navigateToPureAngularRoute('login');
      } else if (url === '/deimpersonate') {
        this.loginService.deImpersonateSubuser();
      } else if (url === '/api-m') {
        // Do nothing
      } else if (url === '/external-auth') {
        this.route.queryParams.subscribe(query => {
          const auth = query.k;
          this.loginService.impersonateUser(auth, true).subscribe(res => {
            this.router.navigate(['']);
          });
        });
      } else if (url === '' || url === '/') {
        this.navigateToPureAngularRoute('dashboard');
      } else {
        url += this.createQueryParamsUrl(this.route.snapshot.queryParams);
        const page = `/s${url}`;
        this.setIframeUrl(page);
      }
    });

    fromEvent(this.wsbiframe.nativeElement, 'load').subscribe((event: Event) => {
      // We need this in case the IFrame follows a redirect.
      const url = this.wsbiframe.nativeElement.contentWindow.location.href;
      const matchArray = url.replace('/s//', '/s/').match(/\/s(\/.*)/);
      if (matchArray) {
        if (matchArray[1] === '' || matchArray[1] === '/' || matchArray[1] === '/dashboard' || matchArray[1] === '/dashboard/welcome') {
          this.iframeReady = false;
          this.navigateToPureAngularRoute(matchArray[1]);
          return;
        }
        this.location.replaceState(matchArray[1]);
        this.wsbFrontendService.notifyNewWsbRoute(matchArray[1]);
      }

      this.registerIFrameListener();
      this.registerLoginListener();

      this.iframeReady = true;
      this.dismissLoadingOverlay();
    });
  }

  navigateToPureAngularRoute(route: string): void {
    this.router.navigate([route]);
    // PWSB-2210 overlay is not active after logout.
    // If overlay is detach the tooltips are not display and it's neccessary to refresh page.
    // this.dismissLoadingOverlay();
  }

  createQueryParamsUrl(queryParams) {
    if (_isEmpty(queryParams)) {
      return '';
    }
    let params = new HttpParams();
    Object.keys(queryParams).forEach(key => {
      params = params.set(key, queryParams[key]);
    });
    return '?' + params.toString();
  }

  showLoadingOverlay() {
    const config = new OverlayConfig();
    config.positionStrategy = this.overlay
      .position()
      .global()
      .centerHorizontally();
    config.hasBackdrop = true;

    this.overlayRef = this.overlay.create(config);
    this.overlayRef.attach(new TemplatePortal(this.loadingTemplate, this.viewContainerRef));
  }

  dismissLoadingOverlay() {
    if (this.overlayRef) {
      this.overlayRef.detach();
    }
    $('.cdk-overlay-container').detach(); // fix
  }

  private setIframeUrl(url: string, registerListeners = true, showLoading = true) {
    let previousUrl = null;
    let newUrl = null;
    try {
      previousUrl = new URL(this.wsbiframe.nativeElement.contentWindow.location.href);
      newUrl = new URL(
        url,
        this.wsbiframe.nativeElement.contentWindow.location.protocol + '//' + this.wsbiframe.nativeElement.contentWindow.location.host
      );
    } catch (e) {}
    if (!previousUrl || !newUrl || previousUrl.pathname !== newUrl.pathname || previousUrl.search !== newUrl.search) {
      this.iframeReady = false;
      this.wsbiframe.nativeElement.contentWindow.location.replace(url);
      if (showLoading) {
        this.showLoadingOverlay();
      }
      if (registerListeners) {
        this.registerLoginListener();
      }
    } else {
      // hash change not triggering iframe load
      this.wsbiframe.nativeElement.contentWindow.location.replace(url);
    }
  }

  private logout(redirect = false): void {
    this.loginService.destroySession();
    this.loginService.logout(redirect);
    this.loginService.clearAllCookies();
  }

  private registerLoginListener() {
    fromEvent(this.wsbiframe.nativeElement.contentWindow, 'message').subscribe((message: any) => {
      if (
        message.origin !==
        this.wsbiframe.nativeElement.contentWindow.location.protocol + '//' + this.wsbiframe.nativeElement.contentWindow.location.host
      ) {
        return; // PayPal sending its own message messing things
      }
      this.zone.run(() => {
        if (message.data && message.data.data === undefined) {
          return;
        }
        const url = message.data;

        if (url.startsWith('/angular_')) {
          this.navigateToPureAngularRoute(url.replace('/angular_', ''));
        } else if (url === '__atlas__login__page') {
          if (this.router.url !== '/user/login' && this.router.url !== '/login') {
            // console.log('Logging out as router URL is ', this.router.url);
            this.logout();
          }
        } else if (url.startsWith('__atlas__impersonate_')) {
          this.loginService.impersonateSubuser(url.substr('__atlas__impersonate_'.length));
          window.location.href = '/dashboard';
        } else {
          // try {
          //   const matchArray = url.match(/\/s(\/.*)/);
          //   // this.router.navigate([matchArray[1]]);
          //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate([matchArray[1]]));
          // } catch (e) {
          //   console.error('registerLoginListener', e);
          // }
        }
        /* php-integration-block end */
      });
    });
  }

  private registerIFrameListener() {
    const wsbiframe = this.wsbiframe;
    fromEvent(this.wsbiframe.nativeElement.contentWindow, 'message').subscribe((message: any) => {
      if (
        message.origin !==
        this.wsbiframe.nativeElement.contentWindow.location.protocol + '//' + this.wsbiframe.nativeElement.contentWindow.location.host
      ) {
        return; // PayPal sending its own message messing things
      }
      this.zone.run(() => {
        if (message.data && message.data.data === undefined) {
          return;
        }
        const url = message.data;

        if (url !== '__atlas__login__page' && !url.startsWith('__atlas__impersonate_')) {
          const matchArray = url.match(/\/s(\/.*)/);
          const matchCurrent = wsbiframe.nativeElement.contentWindow.location.href.match(/\/s(\/.*)/);
          if (matchCurrent && matchCurrent[1] !== matchArray[1]) {
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate([matchArray[1]]));
          } else {
            this.router.navigate([matchArray[1]]);
          }
        }
      });
    });

    /* php-integration-block */
    fromEvent(this.wsbiframe.nativeElement.contentWindow, 'focus').subscribe(() => {
      this.hideDropdown('navbar-dropdown-credits', 'credits-dropdown');
      this.hideDropdown('navbar-dropdown-profile', 'profile-dropdown');
      this.hideDropdown('navbar-dropdown-help', 'help-dropdown');
    });

    fromEvent(this.wsbiframe.nativeElement.contentWindow, 'scroll').subscribe(() => {
      this.iframeScrollService.updateScrollEvent(this.wsbiframe.nativeElement.contentWindow.window);
    });
  }

  private hideDropdown(elementId: string, dropdownId: string) {
    const element = this.document.getElementById(elementId);
    if (element) {
      const isDropdownOpened = this.document.getElementById(elementId).getAttribute('aria-expanded');
      if (isDropdownOpened) {
        this.document.getElementById(elementId).setAttribute('aria-expanded', 'false');
        this.document.getElementById(dropdownId)?.classList.remove('show');
      }
    }
  }
}
